import { defineStore } from "pinia";
import {
  setAxiosHeaders,
  setSampleAxiosUrl,
  resetAxiosUrl,
} from "src/boot/axios";
import { useUserInfo } from "./user-store";
import { resetAllStores } from ".";
import { showSuccess, showError } from "src/utils/notify";
import { Platform, Cookies, LocalStorage } from "quasar";
import { oidc } from "../boot/oidc";
import { useCommonStore } from "./common-store";
import { sendMessageToParentApp } from "src/utils";
import { getAccountAcr } from "src/utils/commonFunction";
import LogRocket from "logrocket";

export const usePersistedStore = defineStore("persisted", {
  state: () => ({
    authData: null,
    count: 0,
    isLoggedIn: false,
    coordinates: null,
    user: null,
    temp_user_info: null,
    isSample: true,
    signUpEmailPhoneExists: "",
    signupAddOnParameters: null,
    firebaseOldToken: "",
    logRocketUser: {},
    // Pending push-notification payload awaiting redirection.
    // Persisted so a full app reload (auth/OIDC, online-event, reloadPage)
    // during startup does not lose the redirect intent.
    pendingNotification: null,
  }),
  getters: {
    getTempUserInfo: (state) => state.temp_user_info,
  },
  actions: {
    increment() {
      this.count++;
    },
    async loginWithIdentity(forwhat = false) {
      const commonStore = useCommonStore();
      if (commonStore.appInIframe || !this.$oidc) return;

      let signInExtraParam = {};

      // if (Platform && Platform.is && Platform.is.cordova)
      // signInExtraParam = {
      //   extraTokenParams: {
      //     atl: 30,
      //   },
      // }

      let splitAcrValue = this.$oidc._settings._acr_values.split(" "),
        tenantAcr = splitAcrValue[0],
        accountAcr = getAccountAcr();

      if (accountAcr) {
        tenantAcr = accountAcr;
      }

      this.$oidc._settings._acr_values = `${tenantAcr} ${
        forwhat == "signup"
          ? "aat:signup"
          : forwhat == "completesignup"
          ? "aat:signup sat:CompleteRegistration"
          : ""
      }`;

      if (!Platform.is.cordova) this.$oidc.signinRedirect(signInExtraParam);
      else {
        try {
          const user = await this.$oidc.signinPopup(signInExtraParam);
          await this.addUser(user);
          return Promise.resolve(user);
        } catch (err) {
          // console.log("err", err);
        }
        // .then(async (user) => {
        //   // reloadPage()
        //   console.log("Here")
        //   await this.mapUser()
        // })
      }
    },
    async login(params) {
      try {
        if (params.email == process.env.SAMPLE_EMAIL) {
          // setSampleAxiosUrl();
          this.isSample = true;
        } else {
          resetAxiosUrl();
          this.isSample = false;
        }
        let userInfo = useUserInfo();
        let res = await this.$request.post(this.apiEndpoints.LOGIN, params);

        this.authData = res.data;
        this.isLoggedIn = true;
        setAxiosHeaders(this.authData.token);

        await userInfo.getUserDetails(); // because we are not reloading the page and this data is needed on the app loading

        showSuccess("Logged in successfully.");

        return {
          success: true,
        };
      } catch (error) {
        // console.log(error);
        showError("Invalid credentials");
        return {
          success: false,
          message: "Invalid credentials",
          errorCode: error.response?.status,
        };
      }
    },
    async logout(router) {
      const commonStore = useCommonStore();
      if (commonStore.appInIframe) {
        sendMessageToParentApp({
          action: "CLOSE_LNS_APP",
        });
      } else {
        // this.resetLogRocketUser();
        setTimeout(() => {
          let tmp_obj = commonStore.storeDetails;
          resetAxiosUrl();
          resetAllStores();
          commonStore.storeDetails = tmp_obj;
        }, 2000);

        if (Platform.is.cordova) {
          await oidc.signoutPopup();
          // ToDo:
          if (router) {
            router.push({ name: "NewLogin" });
            router.go();
          }
        } else await oidc.signoutRedirect();
      }
    },
    getToken() {
      if (this.user) setAxiosHeaders(this.user.access_token);
    },
    async changePassword(params) {
      try {
        let data = await this.$request.post(this.apiEndpoints.CHANGE_PASSWORD, {
          old_password: params.oldPassword,
          new_password: params.newPassword,
        });
        if (data.data) {
          return data.data;
        }
      } catch (error) {}
    },
    setGeoLocation(coordinates) {
      this.coordinates = coordinates;
    },
    async mapUser() {
      const commonStore = useCommonStore();

      try {
        if (!commonStore.appInIframe) {
          let user = await this.$oidc.getUser();
          this.addUser(user);
        }
      } catch (error) {
        // console.log(error);
        this.user = null;
        this.isLoggedIn = false;
      }
    },
    addUser(user) {
      if (user && user.access_token) {
        this.user = user;
        this.isLoggedIn = true;
        setAxiosHeaders(user.access_token);
        this.setLogRocketUser(user);
      } else {
        this.user = null;
        this.isLoggedIn = false;
      }
    },
    resetLogRocketUser() {
      this.logRocketUser = {};
      // Start a new session and end the current one
      LogRocket.startNewSession();
    },
    setLogRocketUser(user) {
      if (
        this.logRocketUser &&
        user &&
        this.logRocketUser?.cst != user?.profile?.cst
      ) {
        this.logRocketUser = {
          name: user?.profile?.name,
          email: user?.profile?.email,
          phone: user?.profile?.phone,
          sid: user?.profile?.sid,
          sub: user?.profile?.sub,
          cst: user?.profile?.cst,
        };
        // Start a new session and end the current one
        // LogRocket.startNewSession();
        // LogRocket.identify(user?.profile?.cst, this.logRocketUser);
      }
    },
    setTempUserInfo(info) {
      this.temp_user_info = info;
    },
    setSampleUrl(param = {}) {
      var emailtmp = "";
      if (param && param.email) {
        emailtmp = param.email;
        // console.log("from param email");
      }
      if (this.user && this.user.profile && this.user.profile.email) {
        emailtmp = this.user.profile.email;
        // console.log("from this.user.profile.email");
      }
      // console.log("emailtmp", emailtmp);
      if (emailtmp.length > 0 && emailtmp == process.env.SAMPLE_EMAIL) {
        // console.log("SAMPLE_EMAIL Url");
        setSampleAxiosUrl();
        this.isSample = true;
      } else {
        // console.log("base Url");
        resetAxiosUrl();
        this.isSample = false;
      }
    },
    checkSample() {
      if (this.isSample) setSampleAxiosUrl();
      resetAxiosUrl();
    },
    setSignUpEmailPhoneExists(emailOrPhone) {
      this.signUpEmailPhoneExists = emailOrPhone;
    },
    setSignupAddOnParameters(payload) {
      if (payload)
        this.signupAddOnParameters = Object.assign(
          {},
          this.signupAddOnParameters || {},
          payload
        );
      else this.signupAddOnParameters = payload;
    },
    updateLoginInfo() {
      try {
        var param = {};
        if (Platform.is.cordova) {
          param.has_used_mobile = 1;
        } else {
          param.has_used_website = 1;
        }
        const data = this.$request.post(
          this.apiEndpoints.UPDATE_LOGIN_TIME,
          param
        );
      } catch (error) {}
    },
    isTutorialShown() {
      if (LocalStorage.getItem("isTutorialShown")) {
        return true;
      } else {
        return false;
      }
    },
  },
  persist: {
    key: "LNSPersistedCookies",
  },
});
